<template>
    <div>
        <el-dialog
        class="BidDialog"
        :title="title"
        :visible.sync="bidShow"
        width="840px"
        :close-on-click-modal="false"
        @close="btnEvent('0')"
        height="600px">
            <div>参与报价人员信息维护</div>
            <div style="margin-top:10px;width: 100%;">
                <el-table :data="contactsInfo" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column prop="contacts" label="选择报价人员" width="200" align="center">
                        <template slot-scope="scope">
                            <span :class="(rowInfo.supplierBidStatus === '5' || rowInfo.supplierBidStatus === '6') ? 'number' : ''" @click="selectContant(scope)">{{scope.row.contacts}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="userCode" label="账号" width="200" align="center">
                        <template slot-scope="scope">
                            <span :style="{'color':scope.row.isNone ? '#ccc' : '#333'}">{{scope.row.userCode}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="idCard" label="身份证号" align="center">
                        <template slot-scope="scope">
                            <span :style="{'color':scope.row.isNone ? '#ccc' : '#333'}">{{scope.row.idCard}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <span v-has="'06010017'">
                                <span v-if="!scope.row.isNone && (rowInfo.supplierBidStatus === '5' || rowInfo.supplierBidStatus === '6')"
                                    class="number" @click="delMumber(scope.row, scope.$index)">删除</span>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="BidDialog-tip">
                <div style="color:#FF8800;">提示：至少选择一名报价人员，点击保存生成应标文件，预览应标文件无误后再点击前往盖章。</div>
                <span v-has="'06010018'">
                    <el-button type="primary" @click="saveBidFile" :loading="saveBidFileload"
                        :disabled="isdisflag || rowInfo.supplierBidStatus === '9' || rowInfo.supplierBidStatus === '11' || rowInfo.supplierBidStatus === '12' || rowInfo.supplierBidStatus === '13'">
                        保存
                    </el-button>
                </span>

            </div>
            <div style="margin-top:10px;">盖章人信息</div>
            <div style="margin-top:10px;width: 100%;">
                <el-table :data="inforowData" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column prop="stamperName" label="盖章人姓名" width="200" align="center">
                        <template slot-scope="scope">
                            <span class="info">{{scope.row.stamperName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stamperIdcard" label="盖章人身份证" width="200" align="center">
                        <template slot-scope="scope">
                            <span class="info">{{scope.row.stamperIdcard}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stamperMobile" label="盖章人联系方式" align="center">
                        <template slot-scope="scope">
                            <span class="info">{{scope.row.stamperMobile}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="margin-top:26px;">应标文件</div>
            <div style="margin-top:10px;width: 100%;">
                <el-table :data="bidFileInfo" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column prop="fileName" label="应标文件名称" align="center">
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="200">
                        <template slot-scope="scope">
                            <span v-has="'06010016'"><el-button size="mini" type="text" @click="actionFn(scope.row, '1')">下载</el-button></span>
                            <span v-has="'06010015'" class="margin-left"><el-button size="mini" type="text" @click="actionFn(scope.row, '2')">预览</el-button></span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-if="rowInfo.supplierBidStatus === '11'"
                    :loading="btnload" size="mini" type="primary" @click="bidSeal('1')">撤回</el-button>
                <el-button v-else-if="rowInfo.supplierBidStatus === '5' || rowInfo.supplierBidStatus === '6'"
                    :loading="btnload" size="mini" type="primary" @click="btnEvent('1')">推送盖章</el-button>
            </div>
        </el-dialog>
        <otpAdvanceDialog ref="contactadvanceDialog" @confirm="detaliSearchSure"> </otpAdvanceDialog>
    </div>
</template>
<script>
import config from '@/config/user.env.js';
import { filePreview } from '@/utils/filePreview.js';
import otpAdvanceDialog from '@/components/lots/otpAdvanceDialog';
import {
    getSupplierStamperInfo, saveStampData, bidFileStamp, getBidFileStampInfo, saveStampDataModule, bidSealWithdrawal, delBidTenderUser
} from '../../../../lsrm/api/myBidding.js';
export default {
    components: { otpAdvanceDialog },
    props: {
        MDialogshow: {
            type: Boolean
        },
        rowBidDialogData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            isdisflag: false,
            saveBidFileload: false,
            title: '应标文件盖章',
            dialogVisible: true,
            inforowData: [],
            rowInfo: {},
            params: {
                name: '联系人',
                value: 'contacts',
                advanceLabel: '选择联系人',
                advanceConfig: [
                    { prop: 'contacts', value: '联系人名称' },
                    { prop: 'idCard', value: '身份证' },
                    { prop: 'contactsMobile', value: '手机号' },
                    { prop: 'userCode', value: '账号' }
                ],
                tableConfig: [
                    { prop: 'contacts', value: '联系人名称' },
                    { prop: 'idCard', value: '身份证' },
                    { prop: 'contactsMobile', value: '手机号' },
                    { prop: 'userCode', value: '账号' }
                ],
                advanceUrl: `/supplier/selectInfoPageByUserCodeIsNotNull?supplierCode=`,
                cbParams: ['contacts#contacts', 'idCard#idCard', 'contactsMobile#contactsMobile', 'userCode#userCode'],
                prefix: '/api-srm-web'
            },
            btnload: false,
            bidShow: false,
            rowIndex: 0,
            isNotFirstSave: true,
            contactsInfo: [{
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }, {
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }, {
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }],
            bidFileInfo: [],
            userIdlist: [],
            moduleNo: '',
            resetSave: false // 重新保存联系人标记
        };
    },
    mounted() {
        this.params.advanceUrl = `/supplier/selectInfoPageByUserCodeIsNotNull?supplierCode=${this.$store.state.supplier.supplierCode}`;
    },
    methods: {
        delMumber(row, index) {
            if (row.id) {
                delBidTenderUser(row.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功！');
                        this.resetSave = true;
                        this.contactsInfo[index] = {
                            contacts: '选择联系人',
                            userCode: '选择联系人自动带出',
                            idCard: '选择联系人自动带出',
                            isNone: true,
                            contactsMobile: ''
                        };
                        this.contactsInfo = [...this.contactsInfo];
                        let flag = false;
                        const userIdlist = [];
                        this.contactsInfo.map((el, i) => {
                            if (el.id) {
                                flag = true;
                                userIdlist.push({
                                    id: el.id
                                });
                            }
                        });
                        if (!flag) {
                            this.isNotFirstSave = false;
                        }
                        this.userIdlist = userIdlist;
                    }
                });
            } else {
                this.$message.success('删除成功！');
                this.contactsInfo[index] = {
                    contacts: '选择联系人',
                    userCode: '选择联系人自动带出',
                    idCard: '选择联系人自动带出',
                    isNone: true,
                    contactsMobile: ''
                };
                this.contactsInfo = [...this.contactsInfo];
            }
        },
        bidSeal() {
            this.btnload = true;
            const par = {
                bidNo: this.rowInfo.bidNo,
                suppliersCode: this.rowInfo.supplierCode,
                cancelType: '1', // 撤回盖章类型，1：应标文件 2：中标价格 3：退款单
                orderNo: this.rowInfo.orderNo,
                operatorName: this.rowInfo.supplierName
            };
            bidSealWithdrawal(par).then(res => {
                this.btnload = false;
                this.bidShow = false;
                if (res && +res.code === 0) {
                    this.$message.success('撤回成功！');
                    this.resetData();
                    this.$emit('mdialogFn', '1');
                    this.$router.push({ name: 'myBidding' });
                }
            });
        },
        actionFn(row, type, index) {
            if (type === '1') {
                window.open(row.fileUrl, '_parent');
            } else {
                filePreview(row);
            }
        },
        detaliSearchSure(res) {
            const flag = this.contactsInfo.find(el => {
                return el.idCard === res.idCard;
            });
            if (flag) {
                this.$message.warning('联系人已选择，请重新选择其他联系！');
                return;
            }
            this.resetSave = true;
            res.isNone = false;
            this.contactsInfo[this.rowIndex] = res;
            this.contactsInfo = [...this.contactsInfo];
        },
        loadData(data) {
            this.resetData();
            this.moduleNo = data.moduleNo;
            this.bidFileInfo = data.bidModuleFiles;
            this.isNotFirstSave = data.bidTenderUsers.length > 0;
            const userIdlist = data.bidTenderUsers.map((el, i) => {
                this.contactsInfo[i] = {
                    contacts: el.tenderUserName,
                    userCode: el.tenderUserCode,
                    idCard: el.idCard,
                    isNone: false,
                    contactsMobile: el.contactNumber,
                    id: el.id ? el.id : null
                };
                return {
                    id: el.id
                };
            });
            this.userIdlist = userIdlist;
            this.contactsInfo = [...this.contactsInfo];
        },
        getInfo() {
            const par = {
                'id': this.rowInfo.id,
                'supplierCode': this.rowInfo.supplierCode
            };
            getBidFileStampInfo(par).then(res => {
                if (res && +res.code === 0) {
                    const data = res.data.data || {};
                    if (JSON.stringify(data) === '{}') {
                        this.isNotFirstSave = false;
                    } else {
                        this.loadData(data);
                    }
                }
            });
        },
        getSupInfo(val) {
            getSupplierStamperInfo(val).then(res => {
                if (res && +res.code === 0) {
                    this.inforowData = [];
                    const data = res.data;
                    data.stamperIdcard = data.stamperIdcard.replace(/(\d{6})\d{6}(\d{3})/, '$1******$2');
                    this.inforowData.push(data);
                }
            });
        },
        selectContant(row) {
            if (this.rowInfo.supplierBidStatus === '5' || this.rowInfo.supplierBidStatus === '6') {
                this.rowIndex = row.$index;
                const current = this.params;
                const advanceCascade = {};
                if (current.advanceCascade && Object.prototype.toString.call(current.advanceCascade) === '[object String]') {
                    let advanceArray = [];
                    advanceArray = current.advanceCascade.split(',');
                    advanceArray.map((item) => {
                        let { 0: sourceProp, 1: destProp } = item.split('#');
                        destProp = destProp || sourceProp;
                        advanceCascade[destProp] = this.formData[sourceProp];
                    });
                }
                this.$refs.contactadvanceDialog.show(true, current, advanceCascade);
            }
        },
        checkmemberFunc() {
            const contInfo = [...this.contactsInfo];
            let idCardNull = false;
            const arr = [];
            contInfo.map(el => {
                if (!el.isNone) {
                    if (!el.idCard) {
                        idCardNull = true;
                    }
                    arr.push({
                        tenderUserName: el.contacts,
                        tenderUserCode: el.userCode,
                        contactNumber: el.contactsMobile,
                        supplierName: this.rowInfo.supplierName,
                        supplierCode: this.rowInfo.supplierCode,
                        bidNo: this.rowInfo.bidNo,
                        bidName: this.rowInfo.bidName,
                        idCard: el.idCard
                    });
                }
            });
            if (arr.length === 0) {
                this.$message.warning('请选择联系人');
                this.saveBidFileload = false;
                return false;
            }
            if (idCardNull) {
                this.$message.warning('身份证不能为空！');
                this.saveBidFileload = false;
                return false;
            }
            return arr;
        },
        saveStampDataFn() {
            const arr = this.checkmemberFunc();
            if (!arr) return;
            saveStampData(arr).then(res => {
                this.saveBidFileload = false;
                if (res && +res.code === 0) {
                    this.resetSave = false;
                    this.bidFileInfo = res.data.bidModuleFiles;
                    this.loadData(res.data);
                    this.$message.success('保存应标文件成功！');
                }
            });
        },
        saveStampDataModuleFn() {
            const contInfo = [...this.contactsInfo];
            const itemList = this.userIdlist.map((el, i) => {
                return {
                    id: el.id,
                    tenderUserName: contInfo[i].contacts,
                    tenderUserCode: contInfo[i].userCode,
                    contactNumber: contInfo[i].contactsMobile,
                    supplierName: this.rowInfo.supplierName,
                    supplierCode: this.rowInfo.supplierCode,
                    bidNo: this.rowInfo.bidNo,
                    bidName: this.rowInfo.bidName,
                    idCard: contInfo[i].idCard
                };
            });
            const arr = [];
            if (itemList.length < contInfo.length) {
                contInfo.map(el => {
                    const flag = itemList.find(item => {
                        return el.userCode === item.tenderUserCode;
                    });
                    if (!flag && !el.isNone) {
                        arr.push({
                            tenderUserName: el.contacts,
                            tenderUserCode: el.userCode,
                            contactNumber: el.contactsMobile,
                            supplierName: this.rowInfo.supplierName,
                            supplierCode: this.rowInfo.supplierCode,
                            bidNo: this.rowInfo.bidNo,
                            bidName: this.rowInfo.bidName,
                            idCard: el.idCard
                        });
                    }
                });
            }
            const params = [...itemList, ...arr];
            let idCardNull = false;
            params.map(el => {
                if (!el.isNone) {
                    if (!el.idCard) {
                        idCardNull = true;
                    }
                }
            });
            if (idCardNull) {
                this.$message.warning('身份证不能为空！');
                this.saveBidFileload = false;
                return;
            }
            saveStampDataModule(params, this.moduleNo).then(res => {
                this.saveBidFileload = false;
                if (res && +res.code === 0) {
                    this.resetSave = false;
                    this.bidFileInfo = res.data.bidModuleFiles;
                    this.loadData(res.data);
                    this.$message.success('保存应标文件成功！');
                }
            });
        },
        saveBidFile() {
            this.saveBidFileload = true;
            if (!this.isNotFirstSave) {
                this.saveStampDataFn(); // 新增
            } else {
                this.saveStampDataModuleFn(); // 修改
            }
        },
        btnEvent(type) {
            if (type === '1') {
                const arr = this.checkmemberFunc();
                if (!arr) return;
                if (this.bidFileInfo.length === 0) {
                    this.$message.warning('请先生成应标文件！');
                    return;
                }
                if (this.rowInfo.supplierBidStatus === '11') {
                    this.$message.warning('已经推送过盖章，请勿重复推送！');
                    return;
                }
                if (this.resetSave) {
                    this.$message.warning('请重新保存联系人！');
                    return;
                }
                this.btnload = true;
                this.isdisflag = true;
                bidFileStamp({ id: this.rowInfo.id,
                    supplierCode: this.rowInfo.supplierCode,
                    bidNo: this.rowInfo.bidNo }).then(res => {
                    this.isdisflag = false;
                    this.btnload = false;
                    if (res && +res.code === 0) {
                        this.$message.success('推送盖章成功！');
                        this.resetData();
                        this.$emit('mdialogFn', '1');
                        const stampUrl = `${config.stampUrl}/html/index.html#/index/home`;
                        const tempwindow = window.open('_blank');
                        tempwindow.location = stampUrl.replace(/'/g, '');
                    }
                });
            } else {
                this.bidShow = false;
                this.resetData();
                this.$emit('mdialogFn');
            }
        },
        resetData() {
            this.contactsInfo = [{
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }, {
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }, {
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }];
        }
    },
    watch: {
        MDialogshow(val) {
            this.bidShow = val;
        },
        rowBidDialogData: {
            handler(val, oldval) {
                if (JSON.stringify(val) !== '{}') {
                    this.rowInfo = val;
                    this.title = (this.rowInfo.supplierBidStatus === '9' ||
                        this.rowInfo.supplierBidStatus === '12' ||
                        this.rowInfo.supplierBidStatus === '13') ? '应标文件预览' : '应标文件盖章';
                    this.getSupInfo(val.supplierCode); // 获取盖章人信息接口
                    this.getInfo(); // 获取盖章联系人和盖章文件列表接口
                }
            },
            deep: true
        }

    }
};
</script>

<style lang="less">
.BidDialog {
    .number {
        color: #00BCBF;
        cursor: pointer;
    }
    .BidDialog-tip {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
    }
    .info {
        font-size: 16px;
        font-weight: 700;
        color: #333;
    }
    .el-table__row {
        font-size: 12px;
    }
}
</style>